import React from "react";

interface TabProps {
  id: string;
  label: string;
  count?: string | number;
}

interface TabItemProps {
  tabList: Partial<TabProps>[];
  activeTab: string;
  handleClick: (d: any) => void;
  hasCardStyles?: boolean;
  tabCountClass?: string;
}

const TabItems: React.FC<TabItemProps> = ({
  hasCardStyles = false,
  tabList = [],
  activeTab = "",
  handleClick = () => { },
  tabCountClass = "",
}) => {
  return (
    <>
      <div className={`${hasCardStyles ? "card py-2" : ""} mb-2 `}>
        <div
          style={{
            overflowX: "auto",
            overflowY: "hidden",
            scrollbarWidth: "none",
          }}
        >
          <ul
            className={`nav nav-tabs border-bottom d-flex flex-nowrap pb-0 px-1 mb-0`}
            style={{ width: "max-content", minWidth: "100%" }}
          >
            {tabList?.map((tab) => {
              // console.log("active Tab;", activeTab, "tab: ", tab);
              return (
                <li className="nav-item" key={tab.id}>
                  <button
                    className={`nav-link border-0 fw-semibol ${activeTab === tab.id
                      ? "active text-primary rounded-0 border-bottom border-primary fw-semibold"
                      : ""
                      }`}
                    onClick={() => handleClick(tab)}
                  >
                    <div className={tabCountClass}>
                      {tab.label}
                      {(tab?.count || tab?.count == 0) && (
                        <div className="text-center">({tab.count})</div>
                      )}
                    </div>
                  </button>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default TabItems;
